import React, { useState, useEffect } from "react";

import "./stylesBetStatuses.css";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { useSearchParams } from "react-router-dom";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

const colors = ["#71BF8A", "#E74C3C", "#9B59B6", "#6177E8", "#F1C40F"];

function BetStatuses() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [isApiRunning, setIsApiRunning] = useState(false);

  const [chartData, setChartData] = useState({
    labels: ["Won", "Lost", "Rejected", "Refunded", "Pending"],
    datasets: [
      {
        label: false,
        data: [0, 0, 0, 0, 0],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  });

  const labels = chartData?.labels;

  const getBetStatuses = async () => {
    setIsApiRunning(true);
    try {
      const requests = [
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_BET_STATUS,
          { event_id: eventId, provider: "sportradar" }
        ),
      ];

      const responses = await Promise.allSettled(requests);
      const [sportradarResponse] = responses;

      if (sportradarResponse.status === "fulfilled") {
        const data = sportradarResponse?.value?.data?.data?.data || [];

        console.log("data betStatuses", data);

        const won = data.find((item) => item.label === "Won")?.value || 0;
        const lost = data.find((item) => item.label === "Lost")?.value || 0;
        const rejected =
          data.find((item) => item.label === "Rejected")?.value || 0;
        const refunded =
          data.find((item) => item.label === "Refund")?.value || 0;
        const pending =
          data.find((item) => item.label === "Pending")?.value || 0;

        setChartData({
          labels: ["Won", "Lost", "Rejected", "Refunded", "Pending"],
          datasets: [
            {
              label: false,
              data: [won, lost, rejected, refunded, pending],
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1,
            },
          ],
        });
      }
    } catch (error) {
      console.log("Error getting bet types:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getBetStatuses();
  }, []);

  return (
    <div className="bet-statuses-container">
      <div className="bet-statuses-header">
        <h2>{AppStrings.BET_STATUSES}</h2>
      </div>
      <div className="bet-statuses-content">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="bet-statuses-chart">
              <Pie data={chartData} options={options} />
            </div>
            <div className="bet-statuses-legend">
              {labels.map((label, index) => (
                <div className="bet-statuses-legend-item" key={index}>
                  <div
                    className="bet-statuses-legend-item-color"
                    style={{ backgroundColor: colors[index] }}
                  />
                  <span className="bet-statuses-legend-item-label">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default BetStatuses;
